class ContentStickScroll {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;

        self.title = self.elem.querySelector('[data-stick-scroll-title]');
        self.titleElem = self.elem.querySelector('[data-stick-scroll-title-elem]');
        self.titleEnd = self.elem.querySelector('[data-stick-scroll-title-end]');
        self.text = self.elem.querySelector('[data-stick-scroll-text]');
        self.textElem = self.elem.querySelector('[data-stick-scroll-text-elem]');
        self.textEnd = self.elem.querySelector('[data-stick-scroll-text-end]');
    }

    init() {
        let self = this;

        self.stickyItem();

        window.onresize = function(event) {
            self.stickyItem();
        };
    }

    stickyItem() {
        let self = this;

        const top = 400;
        const textTop = self.title.offsetHeight + top + 83;

        document.addEventListener('scroll', (e) => {
            const titleOffsetTop = self.titleElem.getBoundingClientRect().top + document.documentElement.scrollTop - top;
            const titleBounding = self.titleEnd.getBoundingClientRect();
            const titleCalc = self.title.offsetHeight + top;
            const titleBoundingCalc = titleBounding.y - self.title.offsetHeight;

            const textOffsetTop = self.textElem.getBoundingClientRect().top + document.documentElement.scrollTop - top;
            const textBounding = self.textEnd.getBoundingClientRect();
            const textCalc = self.text.offsetHeight + top;
            const textBoundingCalc = textBounding.y - self.text.offsetHeight;

            if (window.scrollY > titleOffsetTop) {
                self.title.classList.add('is-sticky');
                self.titleElem.classList.add('is-sticky');
                self.titleElem.style.paddingBottom = self.title.offsetHeight + 'px';
            } else {
                self.title.classList.remove('is-sticky');
                self.titleElem.classList.remove('is-sticky');
                self.titleElem.style.paddingBottom = 0;
            }

            if (window.scrollY > textOffsetTop) {
                self.text.classList.add('is-sticky');
                self.textElem.classList.add('is-sticky');
                self.textElem.style.paddingBottom = self.text.offsetHeight + 'px';
            } else {
                self.text.classList.remove('is-sticky');
                self.textElem.classList.remove('is-sticky');
                self.textElem.style.paddingBottom = 0;
            }

            if (titleCalc > titleBounding.y) {
                self.title.style.top = titleBoundingCalc + 'px';
            } else {
                self.title.style.top = top + 'px';
            }

            if (textCalc > textBounding.y) {
                self.text.style.top = textBoundingCalc + 'px';
            } else {
                self.text.style.top = top + 'px';
            }
        });
    }
}

export default ContentStickScroll;
